import React from 'react'
import Grid from '@material-ui/core/Grid'
import Alert from '@material-ui/lab/Alert'
import dateFormat from 'dateformat'

import getApiUrl from '../../../../lib/getApiUrl'
import {getToken} from '../../../../lib/auth'
import {ensureArray} from '../../../../lib/general'

//must match maxImages in the API's saleImage object
const maxImages = 5

//shows the receipt images saved against the sale, and any newly scanned ones that will be attached on save
export default function SaleImages(props) {
    const saleImages = ensureArray(props.formVals.saleImages)
    const pendingCount = ensureArray(props.formVals.newSaleImageFileIDs).length

    if(saleImages.length === 0 && pendingCount === 0) {
        return (null)
    }

    return (
        <>
            <h4>
                Receipt images
            </h4>
            <Grid container spacing={1}>
                {saleImages.map(si => {
                    const url = getApiUrl() + "/sale/" + props.formVals.saleID + "/image/" + si.saleImageID + "?token=" + getToken()
                    return (
                        <Grid item key={si.saleImageID}>
                            <a href={url} target="_blank" rel="noopener noreferrer" title="Open full size">
                                <img src={url} alt={"Receipt scanned " + dateFormat(si.createdDate, "dd/mm/yyyy HH:MM")} style={{height: 120, maxWidth: "100%", objectFit: "cover", borderRadius: 4, display: "block"}} />
                            </a>
                            <div style={{fontSize: "0.75rem"}}>{dateFormat(si.createdDate, "dd/mm/yyyy HH:MM")}</div>
                        </Grid>
                    )
                })}
                {pendingCount === 0 ? null :
                    <Grid item xs={12}>
                        <Alert severity="info">
                            {pendingCount + " new receipt image" + (pendingCount === 1 ? "" : "s") + " will be attached when you save"}
                            {saleImages.length + pendingCount > maxImages ? ".  Only the latest " + maxImages + " images are kept, so the oldest will be removed" : ""}
                        </Alert>
                    </Grid>
                }
            </Grid>
        </>
    )
}
